import isNil from './isNil';

const getRelativePositionToParent = element => {
    const initialOffset = {
        left : 0,
        right : 0,
        bottom : 0,
        top : 0
    };
    const parent = element.parentElement;
    const parentPosition = !isNil(parent) ? parent.getBoundingClientRect() : initialOffset;
    const elementPosition = element.getBoundingClientRect();

    return {
        left : Math.abs(parentPosition.left - elementPosition.left),
        right : Math.abs(parentPosition.right - elementPosition.right),
        bottom : Math.abs(parentPosition.bottom - elementPosition.bottom),
        top : Math.abs(parentPosition.top - elementPosition.top)
    };
};

export default getRelativePositionToParent;



// WEBPACK FOOTER //
// ./Private/Scripts/helpers/getRelativePositionToParent.js